import { SectionShell } from "@/components/design-system/SectionShell";
import { NavTabs } from "@/components/ui/nav-tabs";

const code = `import { NavTabs } from "@/components/ui/nav-tabs";
import { usePage } from "@inertiajs/react";

const TABS = [
  { href: "/admin/audits", label: "All audits" },
  { href: "/admin/audits/questions", label: "Intake questions" },
];

const { url } = usePage();

<NavTabs tabs={TABS} current={url} label="Audits" className="mt-6" />`;

export function NavTabsSection() {
  return (
    <SectionShell
      id="nav-tabs"
      title="Nav tabs"
      description={
        <>
          A segmented row of links for moving between the sibling pages of one
          section. Each tab is a real URL, so back, refresh and open-in-new-tab
          all behave. Pass <code>usePage().url</code> as <code>current</code>.
          By default the active tab is an exact match on the path, with any query
          string ignored, so <code>?range=30</code> cannot deactivate the tab it
          belongs to. A <code>match</code> callback receives the{" "}
          <em>full</em> url instead — use it for a section whose child pages sit
          under one prefix, or for tabs that differ only by a query param.
        </>
      }
      whenToUse={
        <ul>
          <li>
            A section with two or three sibling pages that share a heading —
            Audits with its list and its intake reference.
          </li>
          <li>
            When each view deserves its own URL because someone will want to
            bookmark, refresh or link it.
          </li>
          <li>
            Below the <code>PageHeader</code>, so the section title reads first
            and the tabs read as a subdivision of it.
          </li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Top-level navigation — that is <code>AdminSidebar</code>, which
            already owns the primary destinations.
          </li>
          <li>
            Swapping content in place without changing the URL. This component
            navigates; it does not toggle panels.
          </li>
          <li>
            More than about four destinations, or labels that need explaining —
            use the sidebar instead.
          </li>
        </ul>
      }
      preview={
        <NavTabs
          current="/admin/audits"
          label="Example"
          tabs={[
            { href: "/admin/audits", label: "All audits" },
            { href: "/admin/audits/questions", label: "Intake questions" },
          ]}
        />
      }
      code={code}
    />
  );
}
